import React, { useEffect, useState } from 'react';
import ExhibitViewOnly from '../../components/tabs/ExhibitViewOnly';
import { authenticatedUserAddress } from '../../services/auth';
import { clientNetwork, exhibitIndexFileName } from '../../lib/constants';
import { fetchData, getUserLoadOutUri } from '../../services/stacks';
import axios from 'axios';

const ViewExhibit = ({ author, fileName, profileAddress,
    // Modal States
    setShowWoopsModal,
    setShowUserContractDeployModal,
    setOpenConfirmModal,
    userContractStatus,
    setShowAdvisoryModal,
    storageUrl,
    // Error State
    setOpenInlineErrorBar,
    setOpenSnackBar,
    setErrorMsg
}) => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState({ title: '', fileName: '', chimed: false, lastUpdated: '', content: '' });
    const [status, setStatus] = useState('');
    const [created, setCreated] = useState('');
    const authUser = authenticatedUserAddress({ network: clientNetwork });

    console.log(profileAddress);

    useEffect(() => {
        async function initViewExhibit() {
            let userLoadoutUrl, exhibitFileContent, userExhibitIndex;
            try {
                if (authUser === author) {
                    userExhibitIndex = await fetchData(exhibitIndexFileName);
                    userExhibitIndex = userExhibitIndex.success ? userExhibitIndex.result : null;
                    console.log("hello admin", authUser, author, profileAddress, userExhibitIndex);
                    if (userExhibitIndex === null) return;

                    userExhibitIndex = userExhibitIndex[fileName];
                    console.log({ userExhibitIndex });

                    exhibitFileContent = await fetchData(userExhibitIndex.fileName, { decrypt: userExhibitIndex.status === 'Draft' ? true : false });
                    exhibitFileContent = exhibitFileContent.success ? exhibitFileContent.result : exhibitFileContent.error;
                    console.log({ exhibitFileContent });
                    setTitle(userExhibitIndex.title);
                    setCreated(exhibitFileContent.lastUpdated);
                    setContent(exhibitFileContent);
                    return;
                }

                if (authUser !== author) {
                    userLoadoutUrl = await getUserLoadOutUri(author);
                    exhibitFileContent = (await axios.get(`${userLoadoutUrl + fileName}?t=${new Date().getTime()}`)).data;
                    if (exhibitFileContent?.wasString) {
                        let index;
                        index = (await axios.get(`${userLoadoutUrl + exhibitIndexFileName}?t=${new Date().getTime()}`)).data;
                        if (index[fileName]) {
                            const { title, status, fileName: filename, chimed, lastUpdated } = index[fileName];
                            exhibitFileContent = { title: title, fileName: filename, chimed, lastUpdated, status, content: `Oops! 🔒 The author hasn't unlocked this Exhibit yet. Stay tuned for the reveal!` };
                        } else {
                            exhibitFileContent = { title: 'N/A', fileName, chimed: false, lastUpdated: 'N/A', status: 'Draft', content: `Oops! 🔒 The author hasn't unlocked this Exhibit yet. Stay tuned for the reveal!` };
                        }
                    }
                    setContent(exhibitFileContent);
                    return;
                }

            } catch (error) {
                console.log({ error });
                setErrorMsg({ msg: "This Exhibit could not be found, check url and try again.", severity: "error" });
                setOpenInlineErrorBar(true);
                setOpenSnackBar(true);
            }

        }
        initViewExhibit();
    }, [])

    console.log({ content });

    return (
        <>
            {content && <ExhibitViewOnly fileName={content.fileName} title={content.title} content={content.content} status={content.status} created={content.lastUpdated} profileAddress={profileAddress}
                setShowWoopsModal={setShowWoopsModal}
                setShowUserContractDeployModal={setShowUserContractDeployModal}
                setOpenConfirmModal={setOpenConfirmModal}
                userContractStatus={userContractStatus}
                storageUrl={storageUrl}
                setShowAdvisoryModal={setShowAdvisoryModal}
                setOpenSnackBar={setOpenSnackBar}
                setErrorMsg={setErrorMsg}
            />}
        </>
    );
};

export default ViewExhibit;